<template>
    <div>
        <button @click="login">Login</button>
        <button v-if="isLogin" @click="logout">Logout</button>
        <p>Login Google? {{ isLogin }}</p>
    </div>
</template>

<script>
import Vue from "vue";
import GAuth from "vue-google-oauth2";

const gauthOption = {
    clientId: '21358604168-g2jvllmp85ioogu0l9dqppb1h7g7t15t.apps.googleusercontent.com',
    scope: 'profile email',
    prompt: 'consent',
    fetch_basic_profile: true,
    plugin_name: 'vue-google-oauth2',
};

Vue.use(GAuth, gauthOption);

export default {
    data() {
        return {
            isLogin: false,
        };
    },
    mounted() {
        // Check if user session exists in localStorage
        const idToken = localStorage.getItem("idToken");
        if (idToken) {
            this.isLogin = true;
            console.log("User is already logged in.");
        }
    },
    methods: {
        async login() {
            try {
                const googleUser = await this.$gAuth.signIn(); // Wait for sign-in
                const idToken = googleUser.getAuthResponse().id_token;

                console.log('Google User:', googleUser);
                console.log('Auth Response:', googleUser.getAuthResponse());
                console.log('ID Token:', idToken);

                if (this.$gAuth.isAuthorized) {
                    // Store the user data and idToken
                    this.$store.dispatch('login', { idToken, email: googleUser.getBasicProfile().getEmail() });

                    this.$router.push({ name: 'training' });
                }
            } catch (error) {
                console.error('Error during Google login:', error);
            }
        },
        logout() {
            this.$gAuth.signOut();
            this.isLogin = false;

            // Clear session from localStorage
            localStorage.removeItem("idToken");
            localStorage.removeItem("email");

            console.log("Logged out successfully.");
            this.$router.push({ name: "home" }); // Redirect to homepage
        },
    },
};
</script>